export const navLinks = [
  {
    name: 'Register',
    href: '/signup',
  },
  {
    name: 'Login',
    href: '/login',
  },
];
